// extracted by mini-css-extract-plugin
module.exports = {"formGroup":"styles_formGroup__isNFf","slider":"styles_slider__SC7kn"};